import { HStack, HStackTypes, Icon, IconTypes, Text, TextTypes } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

export interface ProfitabilityWithIconProps {
  profitability: number;
  profitabilityNormalized?: string;
  iconProps?: IconTypes.Props;
  textProps?: TextTypes.Props;
  containerProps?: HStackTypes.Props;
}

export const ProfitabilityWithIcon: React.FC<ProfitabilityWithIconProps> = ({
  profitability,
  profitabilityNormalized,
  iconProps,
  textProps,
  containerProps,
}) => {
  const positivity = profitability >= 0;
  const profitabilityText = profitabilityNormalized ?? Utils.Mask.Percentage(profitability);

  return (
    <HStack alignItems="center" space="stack.quarck" {...containerProps}>
      <Icon
        name={positivity ? 'ArrowUp' : 'ArrowDown'}
        color={positivity ? 'feedback.success.default' : 'feedback.error.default'}
        size="xxxs"
        {...iconProps}
      />
      <Text {...textProps}>{profitabilityText}</Text>
    </HStack>
  );
};
